<template>
    <div class="feature-view-content">
        <transition mode="out-in" name="fade">
            <div class="apply-logo" v-if="!form.id">
                <img :src="$env.getAppLogo().logo" />
            </div>
            <div class="apply-form-popup-wrap" v-if="form.id">
                <div class="apply-popup-header">
                    <img :src="$env.getAppLogo().logo" />
                    <img :src="form.image" v-if="form.image" />
                </div>
                <div class="apply-form-popup">
                    <transition mode="out-in" name="fade">
                        <keep-alive>
                            <ParentForm
                                @formFilled="formFilled"
                                :form="form"
                                v-if="formVisible"
                            />
                            <ApplyType
                                @typeSelected="typeSelected"
                                @goBack="backToForm"
                                v-if="applyTypeVisible"
                            />
                            <ApplyByLogin
                                :vars="filledVars"
                                @goBack="applyType = ''"
                                @applied="applied"
                                v-if="applyType == 'login'"
                            />
                            <ApplyByRegister
                                :vars="filledVars"
                                @goBack="applyType = ''"
                                @applied="applied"
                                v-if="applyType == 'register'"
                            />
                        </keep-alive>
                    </transition>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    components: {
        ParentForm: () => import('./ParentForm'),
        ApplyType: () => import('./ApplyType'),
        ApplyByLogin: () => import('./ApplyByLogin'),
        ApplyByRegister: () => import('./ApplyByRegister')
    },
    data() {
        return {
            loading: false,
            form: {},
            filledVars: [],
            applyType: ''
        }
    },
    computed: {
        region() {
            return this.$route.query.region
        },
        lang() {
            return this.$route.query.lang
        },
        applyTypeVisible() {
            return (
                this.form.id && this.filledVars.length != 0 && !this.applyType
            )
        },
        formVisible() {
            return this.form.id && this.filledVars.length == 0
        }
    },
    methods: {
        applied() {
            this.$router.push('/status/apply_successful')
        },
        typeSelected(type) {
            this.applyType = type
        },
        backToForm() {
            this.filledVars = []
        },
        formFilled(data) {
            this.filledVars = data
        },
        getForm() {
            setTimeout(async () => {
                const sid = this.$route.params.sid
                const uuid = this.$route.params.uuid

                this.loading = true
                this.$api
                    .get(`v1/contracts/apply/${sid}/${uuid}`)
                    .then(({ data }) => {
                        this.form = data
                    })
                    .catch(error => {
                        this.$Network.handleError(error)
                        this.$router.push('/status/unknown_error')
                    })
                    .then(() => {
                        this.loading = false
                    })
            }, 1500)
        }
    },
    mounted() {
        if (this.region) {
            this.$store.commit('setRegion', this.region)
            this.$query.removeQuery('region')
        }
        if (this.lang) {
            this.$Language.selectLanguage(this.lang)
            this.$query.removeQuery('lang')
        }
        this.getForm()
    }
}
</script>
<style lang="scss" scoped>
.feature-view-content {
    width: 100%;
    height: 100%;
    max-height: 100%;
    padding: 2rem;
    overflow: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 1000px) {
        background: none;
    }
}
.apply-logo {
    background: #fff;
    padding: 3rem 5rem;
    margin: auto 0;
    border-radius: $modal-radius;
    border: $list-border;
}
.apply-logo img {
    width: 10rem;
}
.apply-form-popup-wrap {
    margin: auto 0;
}
.apply-popup-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 1rem;

    img {
        max-width: 10rem;
        max-height: 10rem;
    }

    @media (max-width: 1000px) {
        img {
            max-width: 8rem;
            max-height: 8rem;
        }
    }
}
.apply-form-popup {
    background: #fff;
    border-radius: $modal-radius;
    border: $list-border;
    padding: 1rem;
    z-index: $high;
    display: flex;
    flex-direction: column;
    width: 50rem;

    @media (max-width: 1000px) {
        width: 100vw;
        z-index: $high;
        border: none;
        overflow: hidden;
        overflow-y: auto;
        margin: auto 0;
    }
}
</style>
